import { render, staticRenderFns } from "./FlaggedBackgrounds.vue?vue&type=template&id=c8bd4eb4&scoped=true"
import script from "./FlaggedBackgrounds.vue?vue&type=script&lang=js"
export * from "./FlaggedBackgrounds.vue?vue&type=script&lang=js"
import style0 from "./FlaggedBackgrounds.vue?vue&type=style&index=0&id=c8bd4eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bd4eb4",
  null
  
)

export default component.exports